import './index.css';var ve = Object.defineProperty;
var be = (n, e, t) => e in n ? ve(n, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : n[e] = t;
var d = (n, e, t) => be(n, typeof e != "symbol" ? e + "" : e, t);
import { jsxs as C, jsx as c, Fragment as Te } from "react/jsx-runtime";
import { ExpandDownLight as We, SearchLight as Se, SortLight as Ie, VerticalCustom as Ce, WellClusterLightCustom as Ne, Status as Ae, UsersAltLight as Fe, DrillingRigCustom as we, StarFill as De, StarLight as Le } from "@repo/go-icons";
import { Collapse as U, RadioGroup as Be, Tooltip as w, Loader as ke, RadioButtonGroup as Z, Input as Ee, Button as z, Scrollbar as Ge } from "@repo/go-ui";
import { observer as L } from "mobx-react-lite";
import { useRef as Ve, useMemo as V, useCallback as D, useEffect as X } from "react";
import { initReactI18next as Re, useTranslation as K, I18nextProvider as Ke } from "react-i18next";
import { WELL_STATUSES as Q } from "@repo/core/wells-data-service";
import { WELL_STATUSES as lr } from "@repo/core/wells-data-service";
import { getWellStatusColor as Pe } from "@repo/utils";
import { getWellStatusColor as or } from "@repo/utils";
import je from "i18next";
import Oe from "i18next-browser-languagedetector";
import { action as f, flow as q, makeObservable as Y, observable as y, computed as I } from "mobx";
const ee = {
  block: {
    displayName: "abbreviatedName",
    order: null
  },
  field: {
    displayName: "abbreviatedName",
    order: 1
  },
  pad: {
    displayName: "abbreviatedName",
    order: 2
  }
}, He = { active: "Active", favorites: "Favorites", all: "All" }, $e = { alphabet: "Alphabetically", alphabetAsc: "From A to Z", alphabetDesc: "From Z to A", creationDate: "By creation date", creationDateAsc: "From oldest to newest", creationDateDesc: "From newest to oldest" }, xe = { status: "Status", rig: "Rig type", brigade: "Rig crew", location: "Well location", active: "Active", completed: "Completed" }, Me = "Search", Ue = {
  filter: He,
  sorting: $e,
  grouping: xe,
  search: Me
}, Ze = { list: Ue }, ze = { active: "Activos", favorites: "Favoritos", all: "Todos" }, Xe = { alphabet: "Por orden alfabético:", alphabetAsc: "De A a Z", alphabetDesc: "De Z a A", creationDate: "Por fecha de creación:", creationDateAsc: "De más antiguos a más nuevos", creationDateDesc: "De más nuevos a más antiguos" }, Qe = { status: "Estado", rig: "Tipo de Rig", brigade: "Grupo de perforación", location: "Localizacion del Pozo", active: "Activos", completed: "Completado" }, Je = "Buscar", qe = {
  filter: ze,
  sorting: Xe,
  grouping: Qe,
  search: Je
}, Ye = { list: qe }, et = { active: "Активные", favorites: "Избранное", all: "Все" }, tt = { alphabet: "По алфавиту:", alphabetAsc: "От А до Я", alphabetDesc: "От Я до А", creationDate: "По дате создания:", creationDateAsc: "От поздних к новым", creationDateDesc: "От новых к поздним" }, rt = { status: "Статус", rig: "Буровая установка", brigade: "Буровая бригада", location: "Локация", active: "Активные", completed: "Законченные" }, lt = "Поиск", st = {
  filter: et,
  sorting: tt,
  grouping: rt,
  search: lt
}, ot = { list: st }, it = { ru: ot, en: Ze, es: Ye }, at = {
  caches: ["localStorage", "cookie"],
  lookupCookie: "i18next",
  lookupLocalStorage: "i18nextLng",
  lookupQuerystring: "lng",
  order: ["localStorage", "cookie", "querystring", "path"]
}, P = je.createInstance();
P.use(Oe).use(Re).init({
  detection: at,
  fallbackLng: "en",
  interpolation: {
    escapeValue: !1
  },
  react: {
    useSuspense: !0
  },
  resources: it
});
function te(n) {
  var e, t, r = "";
  if (typeof n == "string" || typeof n == "number") r += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var l = n.length;
    for (e = 0; e < l; e++) n[e] && (t = te(n[e])) && (r && (r += " "), r += t);
  } else for (t in n) n[t] && (r && (r += " "), r += t);
  return r;
}
function re() {
  for (var n, e, t = 0, r = "", l = arguments.length; t < l; t++) (n = arguments[t]) && (e = te(n)) && (r && (r += " "), r += e);
  return r;
}
const nt = "well-collapse-module__wrapper__X87xE", ct = "well-collapse-module__list__tJ-jv", ut = "well-collapse-module__listItem__AIJLE", pt = "well-collapse-module__listItemActive__49M-4", dt = "well-collapse-module__titleWrapper__1fEIj", gt = "well-collapse-module__title__jvuSB", ht = "well-collapse-module__buttons__FhQEW", mt = "well-collapse-module__panelHeader__gDATX", ft = "well-collapse-module__panelHeaderArrow__bXR0E", yt = "well-collapse-module__panelHeaderArrowDown__JhZ-a", _t = "well-collapse-module__panelHeaderText__KIPhy", W = {
  wrapper: nt,
  list: ct,
  listItem: ut,
  listItemActive: pt,
  titleWrapper: dt,
  title: gt,
  buttons: ht,
  panelHeader: mt,
  panelHeaderArrow: ft,
  panelHeaderArrowDown: yt,
  panelHeaderText: _t
}, vt = L(function({
  well: e,
  renderIcon: t,
  onClick: r,
  renderButtons: l,
  refAt: s,
  isActive: o
}) {
  return /* @__PURE__ */ C("div", { className: re(W.listItem, o && W.listItemActive), onClick: r, ref: s == null ? void 0 : s(e.id), children: [
    /* @__PURE__ */ C("div", { className: W.titleWrapper, children: [
      t == null ? void 0 : t(e),
      /* @__PURE__ */ c("p", { className: W.title, children: e.name })
    ] }),
    !!l && /* @__PURE__ */ c("div", { className: W.buttons, onClick: (a) => a.stopPropagation(), children: l() })
  ] });
}), bt = L(function({
  groups: e,
  activeId: t,
  onItemSelect: r,
  refAt: l,
  renderButtons: s,
  activeKey: o,
  renderIcon: a,
  onChange: u
}) {
  const { t: _, i18n: T } = K();
  return /* @__PURE__ */ c(U, { activeKeys: o, collapseClassname: W.wrapper, onChange: u, children: e.map((b) => {
    const v = T.exists(b.name) ? _(b.name) : b.name;
    return /* @__PURE__ */ c(
      U.Panel,
      {
        panelKey: b.id,
        header: /* @__PURE__ */ C("div", { className: W.panelHeader, children: [
          /* @__PURE__ */ c(
            We,
            {
              className: re(W.panelHeaderArrow, o.includes(b.id) && W.panelHeaderArrowDown)
            }
          ),
          /* @__PURE__ */ c("p", { className: W.panelHeaderText, children: v })
        ] }),
        styleBody: { gridTemplateColumns: "100%" },
        children: /* @__PURE__ */ c("ul", { className: W.list, children: b.wells.map((S) => /* @__PURE__ */ c(
          vt,
          {
            renderIcon: a,
            renderButtons: s ? () => s(S) : void 0,
            refAt: l,
            isActive: t === S.id,
            well: S,
            onClick: () => r(S)
          },
          S.id
        )) })
      },
      b.id
    );
  }) });
}), Tt = "well-list-panel-body-module__wrapper__vRvNR", Wt = "well-list-panel-body-module__controlsWrapper__X91L0", St = "well-list-panel-body-module__sortButton__QsGlI", It = "well-list-panel-body-module__contentWrapper__YRcOU", Ct = "well-list-panel-body-module__sortingTooltip__Wrapper__-fj95", Nt = "well-list-panel-body-module__sortingTooltip__optionsContainer__-WpHi", At = "well-list-panel-body-module__icon__Fez32", Ft = "well-list-panel-body-module__searchIcon__dfALD", wt = "well-list-panel-body-module__switchContainer__RKQoM", Dt = "well-list-panel-body-module__groupTypeContainer__TXn0N", Lt = "well-list-panel-body-module__groupTypeButton__ejLAz", Bt = "well-list-panel-body-module__groupTypeIcon__Bdyhq", kt = "well-list-panel-body-module__activeIcon__vdUdB", Et = "well-list-panel-body-module__iconButton__kfIvU", Gt = "well-list-panel-body-module__drillingIcon__gZgce", Vt = "well-list-panel-body-module__loader__wOomF", h = {
  wrapper: Tt,
  controlsWrapper: Wt,
  sortButton: St,
  contentWrapper: It,
  sortingTooltip__Wrapper: Ct,
  sortingTooltip__optionsContainer: Nt,
  icon: At,
  searchIcon: Ft,
  switchContainer: wt,
  groupTypeContainer: Dt,
  groupTypeButton: Lt,
  groupTypeIcon: Bt,
  activeIcon: kt,
  iconButton: Et,
  drillingIcon: Gt,
  loader: Vt
}, Rt = L(function({ sorting: e, changeSorting: t }) {
  const r = Ve(null), { t: l } = K("list"), s = V(() => [
    {
      name: l("sorting.alphabet"),
      items: [
        { label: l("sorting.alphabetAsc"), value: "nameAsc" },
        { label: l("sorting.alphabetDesc"), value: "nameDesc" }
      ]
    },
    {
      name: l("sorting.creationDate"),
      items: [
        {
          label: l("sorting.creationDateDesc"),
          value: "createdAtDesc"
        },
        {
          label: l("sorting.creationDateAsc"),
          value: "createdAtAsc"
        }
      ]
    }
  ], [l]);
  return /* @__PURE__ */ c("div", { className: h.sortingTooltip__Wrapper, ref: r, children: s.map((o) => /* @__PURE__ */ C("div", { className: h.sortingTooltip__optionsContainer, children: [
    /* @__PURE__ */ C("div", { children: [
      o.name,
      ":"
    ] }),
    /* @__PURE__ */ c(Be, { value: e, items: o.items, onChange: (a) => t(a) })
  ] }, o.name)) });
}), G = {
  rig: /* @__PURE__ */ c(we, { className: h.groupTypeIcon }),
  brigade: /* @__PURE__ */ c(Fe, { className: h.groupTypeIcon }),
  status: /* @__PURE__ */ c(Ae, { className: h.groupTypeIcon }),
  location: /* @__PURE__ */ c(Ne, { className: h.groupTypeIcon })
}, Kt = L(function({
  store: e,
  theme: t,
  language: r,
  refAt: l,
  extraWellButtons: s,
  onActiveKeysChange: o,
  onGroupingTypeChange: a,
  onSortingTypeChange: u,
  onSearchValueChange: _,
  onFilterTypeChange: T,
  onWellSelect: b
}) {
  const { t: v } = K("list"), {
    searchValue: S,
    wellGroups: A,
    filterType: B,
    groupingType: k,
    sortingType: E,
    selectedWellId: N,
    activeKeys: oe,
    isLoading: ie,
    setSelectedWellId: ae,
    setGroupingType: j,
    setSortingType: O,
    setFilterType: H,
    changeSearchValue: $,
    setActiveKeys: x,
    toggleFavorite: ne,
    setCallbacks: M
  } = e, ce = (g) => {
    g.id !== N && ae(g.id);
  }, ue = V(() => [
    { label: v("filter.favorites"), value: "favorites" },
    { label: v("filter.active"), value: "active" },
    { label: v("filter.all"), value: "all" }
  ], [v]), pe = V(() => [
    { label: /* @__PURE__ */ c(w, { title: v("grouping.status"), children: G.status }), value: "status" },
    { label: /* @__PURE__ */ c(w, { title: v("grouping.rig"), children: G.rig }), value: "rig" },
    { label: /* @__PURE__ */ c(w, { title: v("grouping.brigade"), children: G.brigade }), value: "brigade" },
    { label: /* @__PURE__ */ c(w, { title: v("grouping.location"), children: G.location }), value: "location" }
  ], [v]), de = (g, F) => {
    g.stopPropagation(), ne(F);
  }, ge = D(
    (g) => {
      H(g);
    },
    [H]
  ), he = D(
    (g) => {
      $(g);
    },
    [$]
  ), me = D(
    (g) => {
      O(g);
    },
    [O]
  ), fe = D(
    (g) => {
      j(g);
    },
    [j]
  ), ye = D(
    (g) => {
      x(g);
    },
    [x]
  ), _e = (g) => /* @__PURE__ */ C(Te, { children: [
    /* @__PURE__ */ c(
      z,
      {
        icon: e.isFavorite(g) ? /* @__PURE__ */ c(De, { className: h.activeIcon }) : /* @__PURE__ */ c(Le, { className: h.icon }),
        variant: "flat",
        onClick: (F) => de(F, g),
        className: h.iconButton
      }
    ),
    s == null ? void 0 : s(g)
  ] });
  return X(() => {
    M({
      onActiveKeysChange: o,
      onFilterTypeChange: T,
      onSortingTypeChange: u,
      onGroupingTypeChange: a,
      onSearchValueChange: _,
      onSelectWell: b
    });
  }, [
    o,
    T,
    a,
    _,
    u,
    b,
    M
  ]), X(() => {
    P.changeLanguage(r.language);
  }, [r.language, e]), /* @__PURE__ */ C("div", { className: h.wrapper, children: [
    ie && /* @__PURE__ */ c(ke, { className: h.loader }),
    /* @__PURE__ */ C("div", { className: h.contentWrapper, children: [
      /* @__PURE__ */ c(
        Z,
        {
          variant: "flat",
          items: ue,
          value: B,
          className: h.switchContainer,
          itemClassName: h.switchButton,
          onChange: ge
        }
      ),
      /* @__PURE__ */ C("div", { className: h.controlsWrapper, children: [
        /* @__PURE__ */ c(
          Ee,
          {
            allowClear: !0,
            prefix: /* @__PURE__ */ c(Se, { className: h.searchIcon }),
            value: S,
            inputClassName: h.searchInput,
            placeholder: v("search"),
            onChange: (g) => he(g.target.value)
          }
        ),
        /* @__PURE__ */ c(
          w,
          {
            placement: "right",
            trigger: ["click"],
            title: /* @__PURE__ */ c(Rt, { sorting: E, changeSorting: me }),
            children: /* @__PURE__ */ c(z, { icon: /* @__PURE__ */ c(Ie, { className: h.sortIcon }), className: h.sortButton })
          }
        )
      ] }),
      /* @__PURE__ */ c(Ge, { children: /* @__PURE__ */ c(
        bt,
        {
          renderIcon: (g) => {
            const F = Pe(g.status, { theme: t });
            return /* @__PURE__ */ c(Ce, { className: h.drillingIcon, style: { color: F } });
          },
          renderButtons: _e,
          groups: A,
          onItemSelect: ce,
          refAt: l,
          activeId: N != null ? N : void 0,
          activeKey: oe,
          onChange: ye
        }
      ) })
    ] }),
    /* @__PURE__ */ c(
      Z,
      {
        variant: "flat",
        items: pe,
        value: k,
        itemClassName: h.groupTypeButton,
        className: h.groupTypeContainer,
        onChange: fe
      }
    )
  ] });
}), er = L(function(e) {
  return /* @__PURE__ */ c(Ke, { i18n: P, children: /* @__PURE__ */ c(Kt, { ...e }) });
});
function Pt(n, e, t, r) {
  return new Promise((l, s) => {
    setTimeout(() => {
      l(e);
    }, n);
  });
}
var jt = Object.defineProperty, Ot = Object.getOwnPropertyDescriptor, i = (n, e, t, r) => {
  for (var l = r > 1 ? void 0 : r ? Ot(e, t) : e, s = n.length - 1, o; s >= 0; s--)
    (o = n[s]) && (l = (r ? o(e, t, l) : o(l)) || l);
  return r && l && jt(e, t, l), l;
};
function le(n) {
  return n < 0 ? -1 : n > 0 ? 1 : 0;
}
const se = (n) => n === "COMPLETED" || n === "ACTIVE_RED";
class m {
  constructor(e, t) {
    d(this, "store");
    d(this, "searchValue");
    d(this, "groupingType");
    d(this, "sortingType");
    d(this, "filterType");
    d(this, "selectedWellId");
    d(this, "activeKeys");
    d(this, "customFilter");
    d(this, "sortByStatus");
    d(this, "locationNameConfigurator");
    var r, l, s, o, a, u, _, T, b, v, S, A, B, k, E, N;
    this.store = e, this.sortingType = (l = (r = t == null ? void 0 : t.sortingType) != null ? r : e.sortingType) != null ? l : null, this.groupingType = (o = (s = t == null ? void 0 : t.groupingType) != null ? s : e.groupingType) != null ? o : null, this.filterType = (u = (a = t == null ? void 0 : t.filterType) != null ? a : e.filterType) != null ? u : null, this.selectedWellId = (T = (_ = t == null ? void 0 : t.selectedWellId) != null ? _ : e.selectedWellId) != null ? T : null, this.searchValue = (v = (b = t == null ? void 0 : t.searchValue) == null ? void 0 : b.trim()) != null ? v : "", this.activeKeys = (S = t == null ? void 0 : t.activeKeys) != null ? S : [], this.customFilter = (B = (A = t == null ? void 0 : t.customFilter) != null ? A : e.customFilterFn) != null ? B : "extend", this.sortByStatus = (k = t == null ? void 0 : t.sortByStatus) != null ? k : !1, this.locationNameConfigurator = (N = (E = t == null ? void 0 : t.locationNameConfigurator) != null ? E : e.locationNameConfigurator) != null ? N : ee, Y(this);
  }
  get filteredWells() {
    return this.allWells.filter((e) => {
      var t, r;
      if (this.searchValue && !e.name.includes(this.searchValue) || this.filterType && this.filterType === "active" && se(e.status) || this.filterType && this.filterType === "favorites" && !this.store.favoritesService.wellIds.includes(e.id))
        return !1;
      if (this.customFilter)
        if (this.customFilter === "extend") {
          if (this.store.customFilterFn)
            return (r = (t = this.store).customFilterFn) == null ? void 0 : r.call(t, e);
        } else
          return this.customFilter(e);
      return !0;
    });
  }
  groupWells(e, t) {
    switch (e) {
      case "status": {
        const r = {};
        return t.forEach((l) => {
          const s = l.status.toLowerCase().includes("active") && l.status !== "ACTIVE_RED" ? "active" : "completed";
          r[s] ? r[s].wells.push(l) : r[s] = {
            id: s,
            wells: [l],
            status: s,
            type: "status",
            name: this.store.getStatusGroupName(s)
          };
        }), Object.values(r);
      }
      case "rig": {
        const r = {};
        return t.forEach((l) => {
          const s = l.rig, o = l.rigModel;
          if (!s) {
            console.error("cannot find rig for well", l.id, l.name);
            return;
          }
          if (!o) {
            console.error("cannot find rig model for well", l.id, l.name);
            return;
          }
          const a = s.id;
          r[a] ? r[a].wells.push(l) : r[a] = {
            id: a.toString(),
            wells: [l],
            rig: s,
            rigModel: o,
            type: "rig",
            name: this.store.getRigGroupName(s, o)
          };
        }), Object.values(r);
      }
      case "location": {
        const r = {};
        return t.forEach((l) => {
          const s = l.pad, o = l.block, a = l.field;
          if (!s || !o || !a) {
            console.error(
              "pad, block or field is missing for well",
              l.id,
              l.name,
              "pad",
              s,
              "block",
              o,
              "field",
              a
            );
            return;
          }
          const u = s.id;
          r[u] ? r[u].wells.push(l) : r[u] = {
            id: u.toString(),
            wells: [l],
            pad: s,
            block: o,
            field: a,
            type: "location",
            name: this.store.getLocationGroupName(o, a, s, this.store.locationNameConfigurator)
          };
        }), Object.values(r);
      }
      case "brigade": {
        const r = {};
        return t.forEach((l) => {
          const s = l.brigade;
          if (!s) {
            console.error("brigade is missing for well", l.id, l.name);
            return;
          }
          const o = s.id;
          r[o] ? r[o].wells.push(l) : r[o] = {
            id: o.toString(),
            wells: [l],
            brigade: s,
            type: "brigade",
            name: this.store.getBrigadeGroupName(s)
          };
        }), Object.values(r);
      }
    }
  }
  get allWells() {
    return this.store.allWells;
  }
  get wells() {
    const e = [];
    if (this.sortByStatus && e.push(J.sortByWellStatus), this.sortingType) {
      const t = this.sortingType;
      typeof t == "string" ? e.push((r, l) => J.sortBySortingType(r, l, t)) : e.push(t);
    }
    return e.length ? [...this.filteredWells].sort((t, r) => e.reduce((l, s, o) => {
      const a = -o;
      return l + Math.pow(le(s(t, r)), a);
    }, 0)) : this.filteredWells;
  }
  get wellGroups() {
    return this.groupingType ? typeof this.groupingType != "function" ? this.groupWells(this.groupingType, this.wells) : this.groupingType(this.wells) : (console.warn("groupingType is not defined"), []);
  }
  setSearchValue(e) {
    var t;
    this.searchValue = (t = e == null ? void 0 : e.trim()) != null ? t : null;
  }
  setFilterType(e) {
    this.filterType = e;
  }
  setSortingType(e) {
    this.sortingType = e;
  }
  setGroupingType(e) {
    this.groupingType = e;
  }
  setSelectedWellId(e) {
    this.selectedWellId = e;
  }
  setActiveKeys(e) {
    this.activeKeys = e;
  }
  setCustomFilterFn(e) {
    e !== this.customFilter && (this.customFilter = e);
  }
  setLocationNameConfigurator(e) {
    this.locationNameConfigurator = e;
  }
}
i([
  y
], m.prototype, "searchValue", 2);
i([
  y
], m.prototype, "groupingType", 2);
i([
  y
], m.prototype, "sortingType", 2);
i([
  y
], m.prototype, "filterType", 2);
i([
  y
], m.prototype, "selectedWellId", 2);
i([
  y
], m.prototype, "activeKeys", 2);
i([
  y
], m.prototype, "customFilter", 2);
i([
  y
], m.prototype, "sortByStatus", 2);
i([
  y
], m.prototype, "locationNameConfigurator", 2);
i([
  I
], m.prototype, "filteredWells", 1);
i([
  I
], m.prototype, "allWells", 1);
i([
  I
], m.prototype, "wells", 1);
i([
  I
], m.prototype, "wellGroups", 1);
i([
  f.bound
], m.prototype, "setSearchValue", 1);
i([
  f.bound
], m.prototype, "setFilterType", 1);
i([
  f.bound
], m.prototype, "setSortingType", 1);
i([
  f.bound
], m.prototype, "setGroupingType", 1);
i([
  f.bound
], m.prototype, "setSelectedWellId", 1);
i([
  f.bound
], m.prototype, "setActiveKeys", 1);
i([
  f.bound
], m.prototype, "setCustomFilterFn", 1);
i([
  f.bound
], m.prototype, "setLocationNameConfigurator", 1);
const p = class R {
  constructor(e, t, r) {
    d(this, "wellsSource");
    d(this, "favoritesService");
    d(this, "locationNameConfigurator");
    d(this, "searchValue");
    d(this, "groupingType");
    d(this, "sortingType");
    d(this, "filterType");
    d(this, "selectedWellId");
    d(this, "activeKeys");
    d(this, "customFilterFn", null);
    d(this, "_callbacks", {});
    d(this, "valueAt");
    d(this, "clearRefs");
    d(this, "isFavorite", (e) => this.favoritesService.wellIds.includes(e.id));
    var l, s, o, a, u, _, T;
    this.wellsSource = e, this.favoritesService = t, this.sortingType = (l = r == null ? void 0 : r.defaultSortingType) != null ? l : "nameAsc", this.groupingType = (s = r == null ? void 0 : r.defaultGroupingType) != null ? s : "location", this.filterType = (o = r == null ? void 0 : r.defaultFilterType) != null ? o : "active", this.selectedWellId = (a = r == null ? void 0 : r.selectedWellId) != null ? a : null, this.searchValue = (u = r == null ? void 0 : r.searchValue) != null ? u : "", this.activeKeys = (_ = r == null ? void 0 : r.activeKeys) != null ? _ : [], this.locationNameConfigurator = (T = r == null ? void 0 : r.locationNameConfigurator) != null ? T : ee, Y(this);
  }
  get allWells() {
    return this.wellsSource.allWells;
  }
  get isLoading() {
    return this.wellsSource.isLoading;
  }
  getStatusGroupName(e) {
    return e === "active" ? "list:grouping.active" : "list:grouping.completed";
  }
  getRigGroupName(e, t) {
    return `${t.name} ${e.rigNumber}`;
  }
  getBrigadeGroupName(e) {
    return e.name;
  }
  getLocationGroupName(e, t, r, l) {
    const s = {
      block: e,
      field: t,
      pad: r
    }, o = [];
    return Object.entries(l).filter(([a, u]) => !!u.order || u.order === 0).sort(([a, u], [_, T]) => u.order - T.order).forEach(([a, { displayName: u }]) => {
      const _ = s[a][u];
      if (!_) {
        console.error(
          `${a} does not contain ${u}`,
          s[a]
        );
        return;
      }
      o.push(_.toString());
    }), o.join(" / ");
  }
  groupWells(e, t) {
    switch (e) {
      case "status": {
        const r = {};
        return t.forEach((l) => {
          const s = l.status.toLowerCase().includes("active") && l.status !== "ACTIVE_RED" ? "active" : "completed";
          r[s] ? r[s].wells.push(l) : r[s] = {
            id: s,
            wells: [l],
            status: s,
            type: "status",
            name: this.getStatusGroupName(s)
          };
        }), Object.values(r);
      }
      case "rig": {
        const r = {};
        return t.forEach((l) => {
          const s = l.rig, o = l.rigModel;
          if (!s) {
            console.error("cannot find rig for well", l.id, l.name);
            return;
          }
          if (!o) {
            console.error("cannot find rig model for well", l.id, l.name);
            return;
          }
          const a = s.id;
          r[a] ? r[a].wells.push(l) : r[a] = {
            id: a.toString(),
            wells: [l],
            rig: s,
            rigModel: o,
            type: "rig",
            name: this.getRigGroupName(s, o)
          };
        }), Object.values(r);
      }
      case "location": {
        const r = {};
        return t.forEach((l) => {
          const s = l.pad, o = l.block, a = l.field;
          if (!s || !o || !a) {
            console.error(
              "pad, block or field is missing for well",
              l.id,
              l.name,
              "pad",
              s,
              "block",
              o,
              "field",
              a
            );
            return;
          }
          const u = s.id;
          r[u] ? r[u].wells.push(l) : r[u] = {
            id: u.toString(),
            wells: [l],
            pad: s,
            block: o,
            field: a,
            type: "location",
            name: this.getLocationGroupName(o, a, s, this.locationNameConfigurator)
          };
        }), Object.values(r);
      }
      case "brigade": {
        const r = {};
        return t.forEach((l) => {
          const s = l.brigade;
          if (!s) {
            console.error("brigade is missing for well", l.id, l.name);
            return;
          }
          const o = s.id;
          r[o] ? r[o].wells.push(l) : r[o] = {
            id: o.toString(),
            wells: [l],
            brigade: s,
            type: "brigade",
            name: this.getBrigadeGroupName(s)
          };
        }), Object.values(r);
      }
    }
  }
  get filteredWells() {
    return this.allWells.filter((e) => !e.name.includes(this.searchValue) || this.filterType === "active" && se(e.status) || this.filterType === "favorites" && !this.favoritesService.wellIds.includes(e.id) ? !1 : this.customFilterFn ? this.customFilterFn(e) : !0);
  }
  get wells() {
    return [...this.filteredWells].sort((e, t) => R.sortByWellStatus(e, t) + le(R.sortBySortingType(e, t, this.sortingType)) / 10);
  }
  get wellGroups() {
    return this.groupWells(this.groupingType, this.wells);
  }
  get selectedWell() {
    var e;
    return (e = this.allWells.find((t) => t.id === this.selectedWellId)) != null ? e : null;
  }
  /**
   * Возвращает объект IWellSource, позволяющий получать отдельный (реактивный) список скважин с гибкой настройкой необходимых фильтров/сортировок/группировок.
   */
  getNewWellSourceInstance(e) {
    return new m(this, e);
  }
  setRefs(e, t) {
    var r;
    (r = this.clearRefs) == null || r.call(this), this.valueAt = e, this.clearRefs = t, this.selectedWellId && this.findAndScrollToWell(this.selectedWellId);
  }
  findAndScrollToWell(e) {
    let t = null;
    for (const r of this.wellGroups) {
      const l = r.wells.find((s) => s.id === e);
      if (l) {
        t = l;
        break;
      }
    }
    t && this.scrollWellIntoView(t.id);
  }
  async *scrollWellIntoView(e) {
    var s;
    const { group: t, selectedWell: r } = this.wellGroups.reduce(
      (o, a) => {
        const u = a.wells.find((_) => _.id === e);
        return u ? {
          selectedWell: u,
          group: a
        } : (o.group && o.selectedWell, o);
      },
      { selectedWell: null, group: null }
    );
    if (!t || !r)
      return;
    !this.activeKeys.includes(t.name) && Array.isArray(this.activeKeys) && (this.activeKeys.push(t.name), yield, await Pt(100), yield);
    const l = (s = this.valueAt) == null ? void 0 : s.call(this, r.id);
    l && l.scrollIntoView({ block: "nearest" });
  }
  setCallbacks(e) {
    this._callbacks = e;
  }
  setCustomFilterFn(e) {
    e !== this.customFilterFn && (this.customFilterFn = e);
  }
  toggleFavorite(e) {
    this.isFavorite(e) ? this.favoritesService.disableFavorite(e.id) : this.favoritesService.enableFavorite(e.id);
  }
  setLocationNameConfigurator(e) {
    this.locationNameConfigurator = e;
  }
  changeSearchValue(e) {
    var t, r;
    this.searchValue = e, (r = (t = this._callbacks).onSearchValueChange) == null || r.call(t, e);
  }
  setFilterType(e) {
    var t, r;
    this.filterType = e, (r = (t = this._callbacks).onFilterTypeChange) == null || r.call(t, e);
  }
  setSortingType(e) {
    var t, r;
    this.sortingType = e, (r = (t = this._callbacks).onSortingTypeChange) == null || r.call(t, e);
  }
  setGroupingType(e) {
    var t, r;
    this.groupingType = e, (r = (t = this._callbacks).onGroupingTypeChange) == null || r.call(t, e);
  }
  setSelectedWellId(e, t) {
    var l, s, o;
    this.selectedWellId = e;
    const r = (l = this.allWells.find((a) => a.id === this.selectedWellId)) != null ? l : null;
    (o = (s = this._callbacks).onSelectWell) == null || o.call(s, r, t);
  }
  setActiveKeys(e) {
    var t, r;
    this.activeKeys = e, (r = (t = this._callbacks).onActiveKeysChange) == null || r.call(t, e);
  }
  updateWellStatus(e, t) {
    this.wellsSource.updateWellStatus(e, t);
  }
  async *fetchWells(e) {
    const t = await this.wellsSource.load();
    return yield, e && this.wellsSource.error && (e.hasError = !0), t;
  }
  static sortBySortingType(e, t, r) {
    switch (r) {
      case "createdAtAsc":
        return e.createdAt - t.createdAt;
      case "createdAtDesc":
        return t.createdAt - e.createdAt;
      case "nameAsc":
        return e.name.localeCompare(t.name);
      case "nameDesc":
        return t.name.localeCompare(e.name);
    }
  }
  static sortByWellStatus(e, t) {
    return Q[e.status] - Q[t.status];
  }
};
i([
  y
], p.prototype, "locationNameConfigurator", 2);
i([
  y
], p.prototype, "searchValue", 2);
i([
  y
], p.prototype, "groupingType", 2);
i([
  y
], p.prototype, "sortingType", 2);
i([
  y
], p.prototype, "filterType", 2);
i([
  y
], p.prototype, "selectedWellId", 2);
i([
  y
], p.prototype, "activeKeys", 2);
i([
  y
], p.prototype, "customFilterFn", 2);
i([
  y
], p.prototype, "_callbacks", 2);
i([
  I
], p.prototype, "allWells", 1);
i([
  I
], p.prototype, "isLoading", 1);
i([
  I
], p.prototype, "filteredWells", 1);
i([
  I
], p.prototype, "wells", 1);
i([
  I
], p.prototype, "wellGroups", 1);
i([
  I
], p.prototype, "selectedWell", 1);
i([
  f.bound
], p.prototype, "findAndScrollToWell", 1);
i([
  q.bound
], p.prototype, "scrollWellIntoView", 1);
i([
  f.bound
], p.prototype, "setCallbacks", 1);
i([
  f.bound
], p.prototype, "setCustomFilterFn", 1);
i([
  f.bound
], p.prototype, "toggleFavorite", 1);
i([
  f.bound
], p.prototype, "setLocationNameConfigurator", 1);
i([
  f.bound
], p.prototype, "changeSearchValue", 1);
i([
  f.bound
], p.prototype, "setFilterType", 1);
i([
  f.bound
], p.prototype, "setSortingType", 1);
i([
  f.bound
], p.prototype, "setGroupingType", 1);
i([
  f.bound
], p.prototype, "setSelectedWellId", 1);
i([
  f.bound
], p.prototype, "setActiveKeys", 1);
i([
  f.bound
], p.prototype, "updateWellStatus", 1);
i([
  q.bound
], p.prototype, "fetchWells", 1);
let J = p;
export {
  lr as WELL_STATUSES,
  er as WellListPanel,
  J as WellListPanelStore,
  ee as defaultLocationNameConfigurator,
  or as getWellStatusColor
};
//# sourceMappingURL=well-list.es.js.map
